<template>
  <div class="flow-wrap">
    <div class="flow">
      <flow-node :source-data="sourceData" :del="handlerDel" :selected-id="selectedId" />
      <flow-node-end />
      <!-- all drawer -->
      <template>
        <!-- 配置审批人 -->
        <drawer-setting
          v-if="drawer"
          :drawer.sync="drawer"
          :node-data="currentNode"
          :director-level="directorLevel"
          @change="handlerChange"
        />
        <!-- 配置抄送人 -->
        <cc-drawer
          v-if="ccDrawer"
          :drawer.sync="ccDrawer"
          :node-data="currentNode"
          :director-level="directorLevel"
          @change="handlerChange"
        />
        <!-- 条件分支 -->
        <branch-setting
          v-if="branchDrawer"
          :drawer.sync="branchDrawer"
          :node-data="currentNode"
          :base-info="baseInfo"
          @change="handlerChange"
        />
      </template>
      <div class="flow-name" v-if="this.baseInfo.audit_type">{{ $t('74') }}: {{ baseInfo.name }}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import drawerSetting from './drawer/approval-drawer'
import ccDrawer from './drawer/cc'
import branchSetting from './drawer/branch-drawer'
import FlowNodeEnd from './node/flow-node-end'
import FlowNode from './node/flow-node'
import { approvalForm, warning, branchFormItem } from './examples'
import { v4 as uuidv4 } from 'uuid'
export default {
  name: 'Flow',
  components: {
    FlowNode,
    drawerSetting,
    branchSetting,
    FlowNodeEnd,
    ccDrawer
  },
  props: {
    // 数据源
    source: {
      type: Object,
      default: () => ({})
    },
    baseInfo: {
      type: Object,
      default: () => {}
    },
    directorLevel: {
      type: Number
    },
    selectData: {
      type: Object,
      default: () => {}
    }
  },
  provide() {
    return {
      updateFlow: this.updateFlow, // 更新视图
      handlerSelected: this.selectdData, // 选中节点的方法
      selectedId: this.selectedId, // 当前选中节点
      handlerAddNode: this.handlerAddNode, // 添加节点
      handerSetting: this.handerSetting // 节点配置
    }
  },
  data() {
    return {
      currentNode: {}, // 当前选中节点
      drawer: false, // 审批人组件展示
      ccDrawer: false, // 抄送人Drawer展示
      branchDrawer: false, // 条件分支组件展示
      sponsorDrawer: false, // 发起人展示
      selectedId: '', // 选中节点ID
      sourceData: this.source.nodeConfig
    }
  },
  computed: {
    type() {
      const audit = this.selectData.audit || []
      const item = audit.filter(item => item.audit_type === this.baseInfo.audit_type)
      return item[0] || {}
    }
  },
  watch: {
    source: {
      handler: function (v) {
        this.sourceData = JSON.parse(JSON.stringify(v.nodeConfig))
      },
      deep: true
    }
  },
  methods: {
    /**
     *  @description 添加节点
     *  @param { Object | Array } item 当前节点或当前条件分支集合
     *  @param { Number } type 节点类型  1 发起人  3 条件分支 2 审批人 7添加多个条件
     */
    handlerAddNode(item, type, branch) {
      if (type === 1 || type === 2) this.handlerApporvalAdd(item, branch, type)
      if (type === 3) this.handlerAddConditional(item, branch)
      // 添加更多条件
      if (type === 7) {
        // if (item.length === 10) return this.$message.warning(this.$t('work_rule_60')) // 添加条件不得超过十条
        item.splice(-1, 0, {
          type: 3,
          nodeName: this.$t('work_rule_49', { x: item.length }),
          nodeCode: uuidv4(),
          form: [[branchFormItem()]],
          isDefault: false,
          warning: warning(3),
          childNode: {
            nodeName: this.$t('work_rule_48'),
            nodeCode: uuidv4(),
            form: approvalForm(),
            warning: warning(1),
            type: 1
          }
        })
      }
      // 更新视图
      this.updateSource()
    },
    /**
     *  @description 审批人添加
     *  @param { Object } data 目标对象
     */
    handlerApporvalAdd(data, branch, type) {
      const { childNode, conditionList } = data
      // 审批人或抄送人
      const msg = {
        nodeName: this.$t(type === 1 ? 'work_rule_48' : '734'),
        nodeCode: uuidv4(),
        form: approvalForm(type === 2),
        warning: warning(1),
        type,
        childNode
      }
      if (branch) {
        this.$set(data, 'childNode', msg)
        return false
      }
      if (conditionList) {
        delete data.conditionList
        msg.conditionList = conditionList
      }
      this.$set(data, 'childNode', msg)
    },
    /**
     *  @description 添加条件
     *  @param { Object } data 目标对象
     */
    handlerAddConditional(data, branch) {
      const { childNode } = data
      const msg = Array.from({ length: 2 }).map((item, index) => {
        return {
          nodeName: index === 1 ? this.$t('work_rule_50') : this.$t('work_rule_49', { x: index + 1 }),
          type: 3,
          nodeCode: uuidv4(),
          isDefault: index === 1,
          form: [[branchFormItem()]],
          warning: warning(3),
          childNode:
            index === 1
              ? null
              : {
                  nodeName: this.$t('work_rule_48'),
                  nodeCode: uuidv4(),
                  form: approvalForm(),
                  warning: warning(1),
                  type: 1
                }
        }
      })
      if (branch) {
        data.childNode = {
          nodeType: 2,
          id: uuidv4(),
          conditionList: msg,
          form: {}
        }
        if (childNode) data.childNode.childNode = childNode
        return false
      }
      data.conditionList = msg
    },
    // 删除节点
    // @parma { obj } 要删除的节点
    handlerDel(obj) {
      const deepDel = data => {
        const { childNode, conditionList } = data
        if (obj.nodeCode === data.nodeCode) return this.handlerDel(data)
        if (conditionList) {
          conditionList.forEach((element, index) => {
            if (element.nodeCode !== obj.nodeCode) return deepDel(element)
            if (conditionList.length <= 2) {
              delete data.conditionList
              if (data.type === 2) this.handlerDel(data)
              return false
            }
            conditionList.splice(index, 1)
          })
        }
        if (!childNode) return false
        // 子节点的childnode 和 conditionList绑定到当前节点上
        if (obj.nodeCode === childNode.nodeCode) {
          delete data.childNode
          if (childNode.childNode) data.childNode = childNode.childNode
          return false
        }
        // 如果子节点还有子节点 把子节点传入
        if (childNode.childNode || childNode.conditionList) deepDel(childNode)
      }
      deepDel(this.sourceData)
      this.updateSource()
    },
    // 视图更新
    updateSource() {
      const source = JSON.parse(JSON.stringify(this.sourceData)) // this.sourceData
      this.sourceData = source
    },
    /**
     *  @param { Object } data 当前选中节点
     *  @description data.type 节点类型 不同节点展示相应组件
     */
    selectdData(data) {
      // 1 发起人 3 条件分支 4 审批人
      switch (data.type) {
        case 0:
          this.sponsorDrawer = true
          break
        case 1:
          this.drawer = true
          break
        case 2:
          this.ccDrawer = true
          break
        case 3:
          this.branchDrawer = !data.isDefault
          break
      }
      // 选中节点
      this.currentNode = data
      // 选中节点ID
      this.selectedId = data.nodeCode
    },
    // 数据存储
    handlerChange(obj) {
      Object.keys(obj).map(item => (this.currentNode[item] = obj[item]))
      this.updateSource()
    },
    save() {
      this.source.nodeConfig = this.sourceData
    }
  }
}
</script>

<style lang="scss" scoped>
@import './node/node.scss';
</style>
